import React from 'react';
import { Button } from '@/components/ui/button';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

const TestPayment = () => {
  const testRedirect = () => {
    console.log('Testing basic redirect...');
    window.location.href = 'https://www.google.com';
  };

  const testAxiosAndRedirect = async () => {
    console.log('Testing axios + redirect...');
    try {
      // Get token from localStorage
      const token = localStorage.getItem('token');
      
      // Get first job
      const jobsRes = await axios.get(`${API_URL}/jobs`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      const job = jobsRes.data.find(j => j.estimated_price > 0);
      
      if (!job) {
        alert('No job with price found');
        return;
      }
      
      console.log('Creating payment for job:', job.id);
      
      const paymentRes = await axios.post(`${API_URL}/payments/create-checkout`, null, {
        params: { 
          job_id: job.id, 
          origin_url: window.location.origin 
        },
        headers: { Authorization: `Bearer ${token}` }
      });
      
      console.log('Payment response:', paymentRes.data);
      
      if (paymentRes.data.checkout_url) {
        console.log('Redirecting to:', paymentRes.data.checkout_url);
        window.location.href = paymentRes.data.checkout_url;
      } else {
        alert('No checkout URL received');
      }
    } catch (error) {
      console.error('Error:', error);
      alert('Error: ' + error.message);
    }
  };

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Payment Test Page</h1>
      <div className="space-y-4">
        <Button onClick={testRedirect}>
          Test Basic Redirect (Google)
        </Button>
        <Button onClick={testAxiosAndRedirect}>
          Test Axios + Payment Redirect
        </Button>
      </div>
    </div>
  );
};

export default TestPayment;
